// extracted by mini-css-extract-plugin
export default {"sortBtn":"SortableColumn_sortBtn__0EGHR"};